<template>
  <m-input-select
    :label="this.$t('common.game')"
    :help-danger="helpDanger"
    :loading="gamesMeta.loading"
    :options="gameOptions"
    :value="selectedGameId"
    :disabled="disabled"
    :fullwidth="fullwidth"
    @input="handleInput"
  />
</template>

<script>
  import { useGames } from '@/views/games/gameHooks'
  import { MInputSelect } from 'codefabrik-gui-vue'
  import { mapState } from 'vuex'

  export default {
    name: 'GameSelect',
    components: { MInputSelect },
    props: {
      helpDanger: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      fullwidth: Boolean,
      nullable: Boolean,
      nullableLabel: {
        type: String,
        default () { return this.$t('common.all') }
      }
    },
    mixins: [
      useGames('games'),
    ],
    methods: {
      handleInput (value) {
        this.$emit('input', value)
      }
    },
    computed: {
      ...mapState('game', ['selectedGameId']),
      gameOptions () {
        const options = this.games.map(it => {
          return { value: it.id, label: it.name }
        })
        if (this.nullable) {
          return [{ value: null, label: this.nullableLabel }, ...options]
        } else {
          return options
        }
      },
    }
  }
</script>

<style scoped>

</style>
